module.exports = __webpack_public_path__ + "img/clock-time.f2a7c0f3.gif";